import { Navigation, Footer } from './components/layout';
import { DisclaimerModal, ScrollToTop } from './components/ui';
import { HeroSection, AboutSection, PracticeAreasSection, OtherServicesSection, ApproachSection, LeadershipSection, ContactSection } from './components/sections';
import { useDisclaimerModal } from './utils/compliance';
import { useNavigation } from './hooks';

function App() {
  const { isModalOpen, isLoading, handleAcceptDisclaimer } = useDisclaimerModal();
  const { activeSection, sections } = useNavigation();

  // Show loading state while checking disclaimer status
  if (isLoading) {
    return (
      <div className="min-h-screen bg-background-white flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary-navy mx-auto mb-4"></div>
          <p className="text-text-medium">Loading...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-background-white">
      {/* Skip to main content link for screen readers */}
      <a 
        href="#main-content" 
        className="sr-only focus:not-sr-only focus:absolute focus:top-4 focus:left-4 bg-primary-navy text-white px-4 py-2 rounded z-50 focus:outline-none focus:ring-2 focus:ring-accent-gold"
      >
        Skip to main content
      </a>

      {/* Navigation */}
      <Navigation activeSection={activeSection} sections={sections} />

      {/* Main Content */}
      <main id="main-content">
        <HeroSection />
        <AboutSection />
        <PracticeAreasSection />
        <OtherServicesSection />
        <LeadershipSection />
        <ApproachSection />
        {/* <InsightsSection /> */}
        <ContactSection />
      </main>

      {/* Footer */}
      <Footer />

      {/* Scroll to Top Button */}
      <ScrollToTop />

      {/* Disclaimer Modal */}
      <DisclaimerModal
        isOpen={isModalOpen}
        onAccept={handleAcceptDisclaimer}
      />
    </div>
  );
}

export default App;
